import { useState } from 'react';
import Tooltip from '@uiw/react-tooltip';
import HeatMap, { HeatMapValue } from '@uiw/react-heat-map';
import styled from 'styled-components';

const ExampleWrapper = styled.div`
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 0 0 1px rgb(16 22 26 / 10%), 0 0 0 rgb(16 22 26 / 0%), 0 1px 1px rgb(16 22 26 / 20%);
  margin: 0 auto;
  margin-top: 70px;
  width: 663px;
  svg {
    border-radius: 5px;
  }
`;

const Tools = styled.div`
  user-select: none;
  font-size: 12px;
  margin-top: 10px !important;
  padding: 10px;
  padding-left: 0px;
  border-radius: 5px;
  width: 663px;
  margin: 0 auto;
  label {
    display: flex;
    align-items: center;
    input {
      margin-right: 5px;
      margin-left: 10px;
    }
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const data1: HeatMapValue[] = [
  { date: '2016/01/11', count: 2, content: '' },
  ...[...Array(17)].map((_, idx) => ({ date: `2016/02/${idx + 10}`, count: idx, content: '' })),
  { date: '2016/03/02', count: 5, content: '' },
  { date: '2016/03/04', count: 11, content: '' },
  { date: '2016/03/14', count: 31, content: '' },
  { date: '2016/03/16', count: 2, content: '' },
  { date: '2016/04/11', count: 2, content: '' },
  { date: '2016/05/01', count: 5, content: '' },
  { date: '2016/05/02', count: 5, content: '' },
  { date: '2016/05/04', count: 11, content: '' },
  { date: '2016/05/14', count: 31, content: '' },
  { date: '2016/05/16', count: 2, content: '' },
  { date: '2016/05/17', count: 2, content: '' },
  { date: '2016/05/18', count: 2, content: '' },
  { date: '2016/05/19', count: 8, content: '' },
  { date: '2016/05/20', count: 6, content: '' },
  { date: '2016/05/21', count: 41, content: '' },
  { date: '2016/05/22', count: 6, content: '' },
  { date: '2016/06/11', count: 2, content: '' },
  { date: '2016/07/01', count: 5, content: '' },
  { date: '2016/07/02', count: 5, content: '' },
  { date: '2016/07/04', count: 11, content: '' },
  { date: '2016/07/14', count: 31, content: '' },
  { date: '2016/07/16', count: 2, content: '' },
  { date: '2016/07/17', count: 2, content: '' },
  { date: '2016/07/18', count: 2, content: '' },
  { date: '2016/07/19', count: 8, content: '' },
  { date: '2016/07/20', count: 6, content: '' },
  { date: '2016/07/21', count: 41, content: '' },
  { date: '2016/07/22', count: 6, content: '' },
  ...[...Array(17)].map((_, idx) => ({ date: `2016/08/${idx + 10}`, count: idx, content: '' })),
];
const data2: HeatMapValue[] = [
  { date: '2016/04/02', count: 5, content: '' },
  { date: '2016/04/04', count: 11, content: '' },
  { date: '2016/04/14', count: 31, content: '' },
  { date: '2016/04/16', count: 2, content: '' },
  { date: '2016/04/17', count: 2, content: '' },
  { date: '2016/04/18', count: 2, content: '' },
  { date: '2016/04/19', count: 8, content: '' },
  { date: '2016/04/11', count: 2, content: '' },
  { date: '2016/04/01', count: 5, content: '' },
  { date: '2016/04/02', count: 5, content: '' },
  { date: '2016/04/04', count: 11, content: '' },
  { date: '2016/04/14', count: 31, content: '' },
  { date: '2016/04/16', count: 2, content: '' },
  { date: '2016/04/17', count: 2, content: '' },
  { date: '2016/04/18', count: 2, content: '' },
  { date: '2016/04/19', count: 8, content: '' },
  { date: '2016/04/20', count: 6, content: '' },
  { date: '2016/04/21', count: 41, content: '' },
  { date: '2016/04/22', count: 6, content: '' },
];

const data3: HeatMapValue[] = [
  { date: '2025/10/24', count: 9, content: 'DST test data' },
  { date: '2025/10/25', count: 12, content: 'DST test data' },
  { date: '2025/10/26', count: 35, content: 'DST test data' },
  { date: '2025/10/27', count: 18, content: 'DST test data' },
  { date: '2025/10/28', count: 11, content: 'DST test data' },
  { date: '2025/10/29', count: 15, content: 'DST test data' },
  { date: '2025/10/30', count: 21, content: 'DST test data' },
  { date: '2025/10/31', count: 7, content: 'DST test data' },
  { date: '2025/11/01', count: 10, content: 'DST test data' },
  { date: '2025/11/02', count: 6, content: 'DST test data' },
  { date: '2026/03/27', count: 16, content: 'DST test data' },
  { date: '2026/03/28', count: 20, content: 'DST test data' },
  { date: '2026/03/29', count: 24, content: 'DST test data' },
  { date: '2026/03/30', count: 14, content: 'DST test data' },
  { date: '2026/03/31', count: 8, content: 'DST test data' },
];

const darkColor = { 0: 'rgb(255 255 255 / 25%)', 8: '#7BC96F', 4: '#C6E48B', 12: '#239A3B', 32: '#ff7b00' };

export default function Example() {
  const [value, setValue] = useState(data1);
  const [selectDate, setSelectDate] = useState<string | undefined>();
  const [enableEndDate, setEnableEndDate] = useState(false);
  const [enableDark, setEnableDark] = useState(false);
  const [enableCircle, setEnableCircle] = useState(false);
  const [enableDstCase, setEnableDstCase] = useState(false);
  const [rectSize, setRectSize] = useState(11);
  const [monthPlacement, setMonthPlacement] = useState<'top' | 'bottom'>('top');
  const [legendCellSize, setLegendCellSize] = useState<number | undefined>();
  const [enableWeekLabels, setEnableWeekLabels] = useState<false | undefined | string[]>(undefined);
  const [enableMonthLabels, setEnableMonthLabels] = useState<false | undefined | string[]>(undefined);
  const startDate = enableDstCase ? new Date('2025/10/01') : new Date('2016/01/01');
  const endDate = enableDstCase ? new Date('2026/04/10') : enableEndDate ? new Date('2016/6/01') : undefined;
  return (
    <Wrapper>
      <ExampleWrapper>
        <HeatMap
          style={{
            backgroundColor: enableDark ? '#000' : '#fff',
            color: enableDark ? '#888' : '#000',
          }}
          panelColors={enableDark ? darkColor : undefined}
          width={663}
          rectSize={rectSize}
          legendCellSize={legendCellSize}
          weekLabels={enableWeekLabels}
          monthLabels={enableMonthLabels}
          startDate={startDate}
          endDate={endDate}
          monthPlacement={monthPlacement}
          value={value}
          rectProps={{
            rx: !enableCircle ? 0 : 5,
            onClick: (e) => {
              setSelectDate((e.target as any).dataset.date);
            },
          }}
          legendRender={(props) => <rect {...props} key={props.key} rx={!enableCircle ? 0 : 5} />}
          rectRender={(props, data) => {
            // if (!data.count) return <rect {...props} />;
            return (
              <Tooltip placement="top" key={data.index} content={`count: ${data.count || 0}`}>
                <rect {...props} />
              </Tooltip>
            );
          }}
          // rectRender={({
          //   rectSize,
          //   column,
          //   space,
          //   row,
          //   fill,
          //   date,
          //   rx,
          //   ...props
          // }: RectDayElement<SVGCircleElement>) => {
          //   if (!enableCircle) return undefined;
          //   return (
          //     <circle
          //       {...props}
          //       fill={fill}
          //       r={rectSize! / 2}
          //       cx={column! * (rectSize! + space!) + 4}
          //       cy={(rectSize! + space!) * row! + 5}
          //       width={rectSize}
          //       height={rectSize}
          //     />
          //   );
          // }}
        />
      </ExampleWrapper>
      <Tools>
        <div style={{ paddingLeft: 10, paddingBottom: 20 }}>
          <button
            onClick={() => {
              setValue(data1);
              setEnableDstCase(false);
            }}
          >
            Value 1
          </button>
          <button
            onClick={() => {
              setValue(data2);
              setEnableDstCase(false);
            }}
          >
            Value 2
          </button>
          <button
            onClick={() => {
              setValue(data3);
              setEnableDstCase(true);
            }}
          >
            DST Value
          </button>
          <span>{selectDate}</span>
          <span style={{ marginLeft: 12, color: '#888' }}>
            {enableDstCase ? 'range: 2025/10/01 - 2026/04/10' : 'range: 2016/01/01 - follow controls'}
          </span>
        </div>
        <label>
          <input type="checkbox" checked={enableEndDate} onChange={(e) => setEnableEndDate(e.target.checked)} />
          endDate = {enableEndDate ? '2016/6/01' : 'undefined'}
        </label>
        <label>
          <input type="checkbox" checked={enableDark} onChange={(e) => setEnableDark(e.target.checked)} />
          {enableDark ? 'Dark' : 'Light'}
        </label>

        <label>
          <input type="checkbox" checked={enableCircle} onChange={(e) => setEnableCircle(e.target.checked)} />
          {enableCircle ? 'Circle' : 'Rect'}
        </label>

        <label style={{ marginTop: 15 }}>
          <input
            type="radio"
            name="weekLabels"
            checked={enableWeekLabels === undefined}
            onChange={(e) => setEnableWeekLabels(undefined)}
          />
          weekLabels = undefined, Default: {JSON.stringify(['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'])}
        </label>
        <label>
          <input
            type="radio"
            name="weekLabels"
            checked={enableWeekLabels === false}
            onChange={(e) => setEnableWeekLabels(false)}
          />
          weekLabels = false
        </label>
        <label>
          <input
            type="radio"
            name="weekLabels"
            checked={Array.isArray(enableWeekLabels)}
            onChange={(e) => setEnableWeekLabels(['日', '一', '', '三', '', '五', '六'])}
          />
          weekLabels = {JSON.stringify(['日', '一', '', '三', '', '五', '六'])}
        </label>

        <label style={{ marginTop: 15 }}>
          <input
            type="radio"
            name="monthLabels"
            checked={enableMonthLabels === undefined}
            onChange={(e) => setEnableMonthLabels(undefined)}
          />
          monthLabels = undefined, Default:{' '}
          {JSON.stringify(['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'])}
        </label>
        <label>
          <input
            type="radio"
            name="monthLabels"
            checked={enableMonthLabels === false}
            onChange={(e) => setEnableMonthLabels(false)}
          />
          monthLabels = false
        </label>
        <label>
          <input
            type="radio"
            name="monthLabels"
            checked={Array.isArray(enableMonthLabels)}
            onChange={(e) =>
              setEnableMonthLabels(['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二'])
            }
          />
          monthLabels = {JSON.stringify(['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二'])}
        </label>

        <div style={{ display: 'flex', marginTop: 10 }}>
          <label>
            <input type="radio" name="rectSize" checked={rectSize === 11} onChange={(e) => setRectSize(11)} />
            rectSize = 11
          </label>
          <label>
            <input type="radio" name="rectSize" checked={rectSize === 12} onChange={(e) => setRectSize(12)} />
            rectSize = 12
          </label>
          <label>
            <input type="radio" name="rectSize" checked={rectSize === 14} onChange={(e) => setRectSize(14)} />
            rectSize = 14
          </label>
        </div>

        <div style={{ display: 'flex', marginTop: 16 }}>
          <label>
            <select value={monthPlacement} onChange={(evn) => setMonthPlacement(evn.target.value as any)}>
              <option value="top">monthPlacement = top</option>
              <option value="bottom">monthPlacement = bottom</option>
            </select>
          </label>
          <label>
            <input
              type="number"
              value={legendCellSize || ''}
              onChange={(e) => setLegendCellSize(Number(e.target.value) || 0)}
            />
            legendCellSize = {legendCellSize}
          </label>
        </div>
      </Tools>
    </Wrapper>
  );
}
